import { Model, Attr, BelongsTo, HasOne, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Lot from './Lot';
import User from './auth/User';

@Model()
export default class Wish extends ApplicationRecord {
  static jsonapiType = 'wishes';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
    ];
  }

  static scopeFactory() {
    return Wish.includes([]);
  }

  @Attr() created: string;

  @HasOne() user: User;
  @HasOne() lot: Lot;
}
